import {apiSlice} from './apiSlice';

/**
 * "API hệ thống" (#25) — quản lý API Key + Webhook outbound của chính user
 * (features/ApiAccess, trang /api-access). Gate theo cờ gói can_use_api: tạo/sửa
 * bị BE trả 402 nếu gói không hỗ trợ; xem/thu hồi/xoá luôn được.
 */
export const apiAccessApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		// ===== API Keys (credential dài hạn, header X-API-Key) =====
		getApiKeys: builder.query({
			query: () => ({url: 'keys', method: 'get'}),
			transformResponse: (body) => body?.data?.keys || [],
			providesTags: ['ApiKey'],
		}),
		// Trả về key ĐẦY ĐỦ đúng 1 lần — FE phải hiện modal cho user copy ngay.
		createApiKey: builder.mutation({
			query: (body) => ({url: 'keys', method: 'post', data: body}),
			transformResponse: (body) => body?.data || null,
			invalidatesTags: ['ApiKey'],
		}),
		revokeApiKey: builder.mutation({
			query: (id) => ({url: `keys/${id}`, method: 'delete'}),
			invalidatesTags: ['ApiKey'],
		}),

		// ===== Webhooks (đẩy sự kiện tới URL ngoài, ký HMAC) =====
		getWebhooks: builder.query({
			query: () => ({url: 'webhooks', method: 'get'}),
			transformResponse: (body) => body?.data || {webhooks: [], events: {}},
			providesTags: ['Webhook'],
		}),
		createWebhook: builder.mutation({
			query: (body) => ({url: 'webhooks', method: 'post', data: body}),
			invalidatesTags: ['Webhook'],
		}),
		updateWebhook: builder.mutation({
			query: ({id, ...body}) => ({url: `webhooks/${id}`, method: 'put', data: body}),
			invalidatesTags: ['Webhook'],
		}),
		deleteWebhook: builder.mutation({
			query: (id) => ({url: `webhooks/${id}`, method: 'delete'}),
			invalidatesTags: ['Webhook'],
		}),
		testWebhook: builder.mutation({
			query: (id) => ({url: `webhooks/${id}/test`, method: 'post'}),
		}),
		// Nhật ký 50 lần gửi gần nhất của 1 webhook (mở lazy trong modal).
		getWebhookDeliveries: builder.query({
			query: (id) => ({url: `webhooks/${id}/deliveries`, method: 'get'}),
			transformResponse: (body) => body?.data?.deliveries || [],
			providesTags: (r, e, id) => [{type: 'Webhook', id: `deliveries-${id}`}],
		}),
	}),
});

export const {
	useGetApiKeysQuery,
	useCreateApiKeyMutation,
	useRevokeApiKeyMutation,
	useGetWebhooksQuery,
	useCreateWebhookMutation,
	useUpdateWebhookMutation,
	useDeleteWebhookMutation,
	useTestWebhookMutation,
	useGetWebhookDeliveriesQuery,
} = apiAccessApiSlice;
